//@ts-check
import { useCallback, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Hook to solve rare/unnecessary re-render
 */
export default function useNavigation() {
  const navigate = useNavigate()
  const navigateRef = useRef({ navigate })
  useEffect(() => {
    navigateRef.current.navigate = navigate
  }, [navigate])
  return useCallback(location => {
    navigateRef.current.navigate(location)
  }, [])
}
